import axios from "axios";
import env from "../variables/EndpointEnvironment";

const NewsBannerAPI = () => {
    return axios.get(`${env.HOST}/informasi-terbaru`, {
        headers: {
            "Content-Language": localStorage.getItem('i18nextLng'),
        },
    });
};

export default NewsBannerAPI;
